const url = {

  // islhurl: 'https://api.eos.h3c.com/islh/v1.0/', // 生产环境

  islhurl: 'https://islh-api.h3c.com/', // 生产环境

  // islhurl: 'https://api.eos-ts.h3c.com/islh/v1.0/', // 测试环境
  //islhurl: 'http://10.90.30.234:8020 '// 测试环境
  // islhurl: 'http://localhost:8020/', // 本地环境
}
export default url



// WEBPACK FOOTER //
// ./src/stores/url.js